import { useNavigate } from "react-router-dom";
import AddCase from "./AddCase";
import CaseProfileExportBuilder from "./CaseProfileExportBuilder";
import ImportCases from "./ImportCases";
import ImportToProfile from "./ImportToProfile";
import ViewCases from "./ViewCases";
import { AppRoutes } from "AppRoutes";
import { useAppSelector } from "redux/hooks";
import { selectClientLensCaseFilters, type LensHomeFeatures } from "redux/slices/clientLens";
import ImportDocumentProperties from "./ImportDocumentProperties";
import LensFiles from "./LensFiles";
import { ViewLensSpecification } from "./ViewLensSpecification";
import { ImportSectionValues } from "./ImportSectionValues";

export interface LensAdminQueryParams {
  view: LensHomeFeatures;
}

const LensAdminManagement = ({ lensId }: { lensId: number }) => {
  const caseFilters = useAppSelector(selectClientLensCaseFilters);
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-3 gap-2 mb-4">
      <ViewCases
        onClick={() => {
          const dest = AppRoutes.lensHomeBuilder(lensId, "cases", "admin", caseFilters);
          navigate(dest);
        }}
      />
      <ImportCases />
      <AddCase />
      <ImportToProfile />
      <CaseProfileExportBuilder
        onClick={() => {
          navigate("export-config");
        }}
      />
      <ImportDocumentProperties lensId={lensId} />
      <LensFiles onClick={() => navigate("files/documents")} />
      <ViewLensSpecification onClick={() => navigate("specification")} />
      <ImportSectionValues />
    </div>
  );
};

export default LensAdminManagement;
